module.exports = __webpack_public_path__ + "static/media/precision_tablet.084571c5.png";